"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Notice = require("./Notice");
Object.keys(_Notice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Notice[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Notice[key];
    }
  });
});